import React from 'react';
import "../Admin/assete/css/adminfooter.css";

const Adminfooter = () => {
  return (
    <footer className="admin-footer">
      <p>&copy; {new Date().getFullYear()} Maathangi Info Research and Solution</p>
    </footer>
  );
};

export default Adminfooter;
